// extracted by mini-css-extract-plugin
export var labelWrapper = "_gk-0";